import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import common from 'src/repositories/common';

const apiKey = '/common/current-account-name';

const useCurrentAccount = () => {
  const { data } = useQuery<AxiosResponse<Response.NameLogin>, AxiosError<any>>(
    [apiKey],
    common.getName,
    {
      retry: 0,
      onError(err) {
        console.log(err.response);
      },
    },
  );
  return {
    name: data?.data.item.name,
    role: data?.data.item.role,
  };
};

export default useCurrentAccount;
